"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP);
export default function Pharmahero() {
  const container = useRef<HTMLDivElement>(null);
  const headlineWords = "Especialistas em Pulverização desde 1937".split(" ");
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".es-eyebrow", {
        y: -8
      });
      gsap.to(".es-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out"
      });
      gsap.set(".es-word", {
        y: 24
      });
      gsap.to(".es-word", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        stagger: 0.04,
        ease: "power3.out",
        delay: 0.15
      });
      gsap.set(".es-body", {
        y: 16
      });
      gsap.to(".es-body", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        ease: "power3.out",
        delay: 0.9
      });
      gsap.to(".es-bokeh", {
        xPercent: 3,
        duration: 22,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true
      });
      gsap.set(".es-bokeh", {
        opacity: 0
      });
      gsap.to(".es-bokeh", {
        opacity: 1,
        duration: 1.2,
        ease: "power2.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".es-eyebrow", ".es-word", ".es-body", ".es-bokeh"], {
        opacity: 1,
        y: 0
      });
    });
  }, {
    scope: container
  });
  return <section data-section-id="26822" id="pharmahero" data-nav="dark" className="relative overflow-hidden bg-primary text-primary-foreground min-h-[80vh] py-32 md:py-44" ref={container}>
      {}
      <div className="es-bokeh pointer-events-none absolute inset-0 -z-10" aria-hidden="true" style={{
      opacity: 0
    }}>
        {}
        <div className="absolute inset-0" style={{
        background: "radial-gradient(ellipse 80% 60% at 50% 20%, hsl(215 90% 45% / 0.35) 0%, hsl(215 80% 20% / 0.18) 30%, hsl(220 22% 6% / 0.6) 65%, hsl(220 22% 6%) 100%)"
      }} />
        {}
        <div className="absolute left-[8%] top-[18%] h-72 w-72 rounded-lg" style={{
        background: "hsl(215 90% 45% / 0.55)",
        filter: "blur(90px)"
      }} />
        <div className="absolute left-[38%] top-[8%] h-96 w-96 rounded-lg" style={{
        background: "hsl(210 20% 98% / 0.4)",
        filter: "blur(110px)"
      }} />
        <div className="absolute right-[10%] top-[24%] h-80 w-80 rounded-lg" style={{
        background: "hsl(215 80% 20% / 0.55)",
        filter: "blur(100px)"
      }} />
        <div className="absolute left-[22%] top-[46%] h-56 w-56 rounded-lg" style={{
        background: "hsl(215 90% 45% / 0.35)",
        filter: "blur(80px)"
      }} />
        <div className="absolute right-[28%] top-[38%] h-64 w-64 rounded-lg" style={{
        background: "hsl(215 90% 45% / 0.32)",
        filter: "blur(90px)"
      }} />
        {}
        <div className="absolute inset-x-0 top-0 h-40" style={{
        background: "linear-gradient(to bottom, hsl(215 90% 45% / 0.28), transparent)"
      }} />
        {}
        <div className="absolute inset-x-0 bottom-0 h-1/2" style={{
        background: "linear-gradient(to top, hsl(220 22% 6%) 0%, hsl(220 22% 6% / 0.4) 60%, transparent 100%)"
      }} />
      </div>

      {}
      <div className="relative mx-auto flex min-h-[calc(80vh-16rem)] max-w-[1080px] flex-col items-center justify-center px-6 text-center md:px-10">
        {}
        <div className="es-eyebrow mb-10 md:mb-14" style={{
        opacity: 0,
        color: "hsl(210 20% 98%)"
      }}>
          <span className="font-mono text-xs font-medium uppercase" style={{
          letterSpacing: "0.22em"
        }}>
            Eurocontrol
          </span>
        </div>

        {}
        <h1 className="mx-auto max-w-[900px] font-default font-normal" style={{
        fontSize: "clamp(2.75rem, 5.4vw + 0.5rem, 6.5rem)",
        letterSpacing: "-0.035em",
        lineHeight: 0.98,
        color: "hsl(210 20% 98%)"
      }}>
          {headlineWords.map((word, i) => <span key={i} data-index={i} className="es-word inline-block" style={{
          opacity: 0,
          marginRight: "0.28em"
        }}>
              {word}
            </span>)}
        </h1>

        {}
        <p className="es-body mx-auto mt-10 max-w-[640px] font-default md:mt-12" style={{
        opacity: 0,
        fontSize: "clamp(1.0625rem, 0.35vw + 1rem, 1.1875rem)",
        letterSpacing: "-0.005em",
        lineHeight: 1.55,
        color: "hsl(215 12% 70%)"
      }}>
          Representantes Exclusivos da Spraying Systems Co. desde 1993.
        </p>
      </div>
    </section>;
}